import BaseComponent from './BaseComponent';

class SignUp extends BaseComponent {
  constructor(componentName){
    super(componentName);
  }


  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    const element     = component.element;
    const newUserForm = document.getElementsByClassName('form--signup')[0];
    const modalSignup = document.getElementsByClassName('modal--signup')[0];

    if(!!newUserForm) {
      this.email    = newUserForm.getElementsByClassName('email-field')[0];
      this.password = newUserForm.getElementsByClassName('password-field')[0];
    }

    element.addEventListener('click', (e) => {
      const step = element.getAttribute('data-step');

      // CHECK EMAIL BEFORE ENABLING NEXT ON BTN
      if(step == 'next' && this.email.checkValidity() && this.password.checkValidity()) {
        updateClass ('confirmation-js', 'show');
        updateClass('sign-up-social-js', 'show', false);
        updateClass('email-field', 'confirmation');
      } else {
        updateClass('confirmation-js', 'show', false);
        updateClass('email-field', 'confirmation', false);
        updateClass ('sign-up-social-js', 'show');
      }
    });


    function updateClass(selector, myClass, add = true) {
      const elements = document.getElementsByClassName(selector);
      // add/remove class to all chosen elements
      for(let element of elements) {
        if(add) {
          element.classList.add(myClass);
          if(!!modalSignup) modalSignup.classList.add(myClass);
        } else {
          element.classList.remove(myClass);
          if(!!modalSignup) modalSignup.classList.remove(myClass);
        }
      }
    }
  }


}

export default SignUp;
